import { Container } from '@mui/material';
import { IApiCallStatus, ValueLabel, variables } from '../common';
import { renderCsaStack, ICsaRequestStatus } from '.';

export function CsaRequestStatusStack({
  properties,
  requests,
  getRequstsCallStatus,
}: {
  properties: ValueLabel<keyof ICsaRequestStatus>[];
  requests: ICsaRequestStatus[];
  getRequstsCallStatus: IApiCallStatus;
}) {
  const s = useStyles;
  switch (getRequstsCallStatus) {
    case null:
      return <Container maxWidth="lg">Loading...</Container>;

    case false:
      return <Container maxWidth="lg">Error</Container>;

    case true:
      return <>{renderCsaStack(s)(properties)(requests)}</>;

    case void 0:
      return null;

    default:
      return <Container maxWidth="lg">Idk</Container>;
  }
}

const useStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',

    '&>*+*': {
      marginTop: '0.5rem',
    },
  },

  itemWrapper: {
    paddingBottom: '0.5rem',
    borderBottom: variables.cardBorder,
  },

  line: {
    maxHeight: '10em',
    overflow: 'auto',

    '&>*+*': {
      marginLeft: '1rem',
    },
  },

  label: {
    fontWeight: 700,
  },

  pair: {
    display: 'flex',
    alignItems: 'center',
    '&>*+*': {
      marginLeft: '1rem',
    },
  },
};
